import React from 'react';
import styles from './index.css';
import PropTypes from 'prop-types';
import { cookie } from '@ifeng/ui_base';
import errorBoundary from '@ifeng/errorBoundary';
import { getShortRecommend } from '../../../../services/api';
import ShortVideo from './shortVideo';
import ShortPic from './shortPic';

class RelateRecom extends React.PureComponent {
    static propTypes = {
        base62Id: PropTypes.string,
        wxLaunch: PropTypes.object,
    };

    state = {
        shortData: [],
    };

    componentDidMount() {
        this.getShortRecommendData();
    }

    getShortRecommendData = async () => {
        const { base62Id } = this.props;
        const config = {
            deviceId: this.createUid(),
            id: `ucms_${base62Id}`,
            from: 'snews_share_relate',
            os: this.getSystem(),
            uid: this.createUid(),
            proid: 'ifengnewsh5',
            gv: '7.1.0',
            publishid: '2006',
        };
        const result = await getShortRecommend(config);

        if (result && result[0] && result[0].item) {
            const data =
                result[0].item &&
                result[0].item.map(item => {
                    let intro = '';

                    if (item.intro && item.intro.length > 31) {
                        intro = `${item.intro.slice(0, 31)}... <span class=${
                            styles.shortAppTxt
                        } style={}>应用内查看全文</span>`;
                    } else if (item.intro && item.intro.length < 31 && item.intro.length > 0) {
                        intro = `${item.intro}<span class=${styles.shortAppTxt}> 应用内查看全文</span>`;
                    } else {
                        intro = '';
                    }

                    return {
                        ...item,
                        intro,
                    };
                });

            this.setState({
                shortData: data,
            });
        }
    };

    getSystem = () => {
        const UA = navigator.userAgent.toLowerCase();

        if (UA.match(/android/)) {
            return 'android';
        } else {
            return 'iphone';
        }
    };

    createUid = () => {
        if (cookie.get('userid') !== '') return cookie.get('userid');
        const key = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-';
        let ramStr = parseInt(Math.random() * 268435455).toString(2);
        let mtimeStr = new Date().getTime();

        mtimeStr = mtimeStr.toString(2);
        while (ramStr.length < 28) ramStr = `0${ramStr}`;
        while (mtimeStr.length < 44) mtimeStr = `0${mtimeStr}`;

        const binaryStr = ramStr + mtimeStr;
        let outStr = '';

        for (let i = 0; i < 12; i++) outStr += key.charAt(parseInt(binaryStr.substr(i * 6, 6), 2));

        return outStr;
    };

    render() {
        const { shortData } = this.state;
        const { wxLaunch } = this.props;

        return (
            <section className={styles.relateShortRecom}>
                {shortData.length > 0 &&
                    shortData.map(
                        (item, index) =>
                            item &&
                            item.style &&
                            item.style.view &&
                            (item.style.view === 'wbcommitvideobigimg' ? (
                                <ShortVideo key={index} wxLaunch={wxLaunch} content={item} />
                            ) : (
                                <ShortPic key={index} wxLaunch={wxLaunch} content={item} />
                            )),
                    )}
            </section>
        );
    }
}

export default errorBoundary(RelateRecom);
